import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router";
import { useArchiveSupplier } from "src/api/client-api/company/useArchiveSupplier";
import { useSnackbar } from "src/utils/useSnackbar";
import { CompanyGrid } from "src/api/client-api/company/useGetAllOrganization";
import { organizationSuppliersKey } from "src/api/client-api/company/useGetOrganizationSuppliers";
import { MenuItemType } from "src/components/ActionsPopover/ActionsPopover.types";
import { FoodsIcon } from "@foodpilot/foods";
import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import { URLHandler } from "src/services/URLHandler";
import type { ComponentAppearance } from "src/components/appearance";

type MenuItemsOptions = {
    appearance?: ComponentAppearance;
    companyIds: {
        "@id": IRI;
        id: number;
    };
};
export const useSuppliersGridMenuItems = (options: MenuItemsOptions) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const deleteSupplier = useArchiveSupplier();
    const queryClient = useQueryClient();
    const snackbar = useSnackbar();

    const { appearance = "legacy", companyIds } = options;

    const menuItemsAcc: MenuItemType<CompanyGrid>[] = [];

    menuItemsAcc.push({
        icon: <FoodsIcon icon="scoresIndicators" size={3} />,
        label: t("scores_indicateurs_cles"),
        onClick: () => {},
        isDisabled: true,
        shouldShow: (entity) => {
            return entity?.canView ?? false;
        },
    });

    menuItemsAcc.push({
        icon: <FoodsIcon icon="questionnaires" size={3} />,
        label: t("questionnaire"),
        onClick: () => {},
        isDisabled: true,
        shouldShow: (entity) => {
            return entity?.canView ?? false;
        },
    });

    menuItemsAcc.push({
        icon: <FoodsIcon icon="informations" size={3} />,
        label: t("informations"),
        onClick: () => {},
        isDisabled: true,
        shouldShow: (entity) => {
            return entity?.canView ?? false;
        },
    });

    menuItemsAcc.push({
        icon: appearance === "product-v2" ? <FoodsIcon icon="edit" size={3} /> : <Edit />,
        label: t("modifier"),
        onClick: (entity) => {
            navigate(URLHandler.supplier.edit(companyIds.id, entity.id, 0));
        },
        shouldShow: (entity) => {
            return entity?.canModify ?? false;
        },
    });

    menuItemsAcc.push({
        icon: appearance === "product-v2" ? <FoodsIcon icon="delete" size={3} /> : <Delete />,
        label: t("supprimer"),
        onClick: (entity) => {
            deleteSupplier.mutate(entity.id, {
                onSuccess: () => {
                    queryClient.invalidateQueries({ queryKey: organizationSuppliersKey });
                },
                onError: () => {
                    snackbar.setSnackbarProps({
                        message: t(
                            "la_suppression_du_fournisseur_n_est_pas_possible_car_un_utilisateur_lui_est_rattache.",
                        ),
                        type: "error",
                    });
                },
            });
        },
        shouldShow: (entity) => {
            return entity?.canDelete ?? false;
        },
    });

    return menuItemsAcc;
};
